import { Column, Index } from 'typeorm';
import type { TradeShowTodoSource } from '../../constants/trade-shows';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * Where one of a show's to-dos came from (PD-17632). The to-do itself is an
 * ordinary task linked to the show through `event_link`; this row records the
 * checklist item or directory deadline behind it, so a checklist isn't applied
 * twice and a directory deadline can follow the organizer when a date moves. A
 * to-do added by hand has no row here.
 */
@Entity('trade_show_todo')
@Index('idx_trade_show_todo_show', ['tradeShowId'])
export class TradeShowTodoEntity extends BaseEntity {
	@Column('int', { name: 'fk_trade_show__id' })
	public tradeShowId!: number;

	@Column('int', { name: 'fk__event__id' })
	public eventId!: number;

	@Column('varchar', { name: 'source', length: 20 })
	public source!: TradeShowTodoSource;

	/** `checklist:<item id>` or `directory:<column>`: what this to-do answers. */
	@Column('varchar', { name: 'sourceKey', length: 80 })
	public sourceKey!: string;

	/** For a directory deadline, the date last used, to tell when the organizer moved it. */
	@Column('date', { name: 'sourceDate', nullable: true })
	public sourceDate?: string | null;
}
